<main class="target-page">
<div class="target-summary-bar">
  <div class="target-stat target-total">
    <i class="fas fa-bullseye"></i>
    <ng-container *ngIf="isTeilerDisplay; else normalTotal">
      Decimalno skupaj: {{ getTotalDecimalShotValue(targetData[0]) }}
      <span class="target-stat-label">Teiler skupaj: {{ getTotalTeilerValue() }} | Najmanjši Teiler: {{ getMinimumTeilerValue() }}</span>
    </ng-container>
    <ng-template #normalTotal>
      <ng-container *ngIf="isDecimalPrimaryDisplay; else wholeNumberTotal">Skupaj: {{ getTotalDecimalShotValue(targetData[0]) }} / {{ getTotalShotValue(targetData[0]) }}</ng-container>
      <ng-template #wholeNumberTotal>Skupaj: {{ getTotalShotValue(targetData[0]) }}<ng-container *ngIf="showDecimalValues"> / {{ getTotalDecimalShotValue(targetData[0]) }}</ng-container></ng-template>
    </ng-template>
    <span class="target-stat-label">Notranji centri: {{ getTotalInnerCenters() }}</span>
  </div>
  <div class="target-stat">
    <span class="target-stat-label">Samodejno določena tarča</span>
    <span>{{ getTargetTypeLabel(effectiveTargetType) }}</span>
  </div>
  <div class="target-stat" *ngIf="selectedXmlTarget">
    <span class="target-stat-label">XML preglasitev</span>
    <span>{{ selectedXmlTarget.displayName }}</span>
  </div>
  <div class="target-stat">
    <span class="target-stat-label">Ime strelca</span>
    <span>{{ targetData[0]?.member_full_name || '-' }}</span>
  </div>
  <div class="target-stat">
    <span class="target-stat-label">Tekmovanje</span>
    <span>{{ targetData[0]?.competition_name || '-' }}</span>
  </div>
  <div class="target-summary-actions">
    <button type="button" title="Prenesi poročilo v PDF" class="target-action-button" (click)="downloadPdf()">
      <i class="fas fa-file-pdf"></i>
      <span>Prenesi PDF</span>
    </button>
    <button type="button" class="target-action-button" (click)="toggleView()">
      <img src="assets/switch.png" alt="Preklopi prikaz" class="w-8 h-8 mr-2" />
      Zamenjaj pregled
    </button>
  </div>
</div>

<div *ngIf="selectedShotIndex !== null && shots[selectedShotIndex] as selectedShot" class="target-selected-shot">
  Izbran strel {{ selectedShot.TargetShotZAP }}:
  <ng-container *ngIf="isTeilerDisplay; else selectedNormal">{{ getShotDecimalValue(selectedShot) }} / Teiler {{ getShotTeilerValue(selectedShot) }}</ng-container>
  <ng-template #selectedNormal>
    <ng-container *ngIf="isDecimalPrimaryDisplay; else selectedWholeValue">
      {{ getShotDecimalValue(selectedShot) }} ({{ formatShotValue(getShotDecimalValue(selectedShot)) }})
    </ng-container>
    <ng-template #selectedWholeValue>{{ formatShotValue(getShotDecimalValue(selectedShot)) }}<span *ngIf="showDecimalValues"> ({{ getShotDecimalValue(selectedShot) }})</span></ng-template>
  </ng-template>
</div>
  
<div class="target-content">


  <div *ngIf="!isSeriesView">
    <!-- Default View -->

    <!-- Optionally, show the total sum below all columns -->
    <div class="mt-4 font-bold">
      <ng-container *ngIf="isTeilerDisplay; else allSeriesNormal">
        Decimalno skupaj: {{ getTotalDecimalShotValue(targetData[0]) }} | Teiler skupaj: {{ getTotalTeilerValue() }} | Najmanjši Teiler: {{ getMinimumTeilerValue() }}
      </ng-container>
      <ng-template #allSeriesNormal>
        <ng-container *ngIf="isDecimalPrimaryDisplay; else allSeriesWhole">Skupaj vseh serij: {{ getTotalDecimalShotValue(targetData[0]) }} / {{ getTotalShotValue(targetData[0]) }}</ng-container>
        <ng-template #allSeriesWhole>Skupaj vseh serij: {{ getTotalShotValue(targetData[0]) }}<ng-container *ngIf="showDecimalValues"> / {{ getTotalDecimalShotValue(targetData[0]) }}</ng-container></ng-template>
      </ng-template>
      <span class="ml-4">Notranji centri skupaj: {{ getTotalInnerCenters() }}</span>
    </div>
   
    <div class="target-default-layout">
      <div class="flex-none">
        <canvas #targetCanvas width="700" height="700" class="target-main-canvas"></canvas>
      </div>
      <div class="flex-1">
        <div class="flex flex-row gap-8 mt-6 flex-wrap">
          <ng-container *ngFor="let group of [0,1,2,3,4,5]; let idx = index">
            <table class="target-shot-table" *ngIf="getSeriesShots(idx).length > 0">
              <thead>
                <tr>
                  <th class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">Strel</th>
                  <th *ngIf="!isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">{{ isDecimalPrimaryDisplay ? 'Decimalno' : 'vrednost' }}</th>
                  <th *ngIf="showDecimalValues && !isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">decimalna vrednost</th>
                  <th *ngIf="isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">Celi</th>
                  <th *ngIf="isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">Teiler</th>
                  <th class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">Notranji center</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let shot of getSeriesShots(idx)">
                  <tr (click)="selectShot(getShotIndex(shot))" [class.selected-shot-row]="selectedShotIndex === getShotIndex(shot)" class="cursor-pointer hover:bg-yellow-50">
                    <td class="border border-gray-300 px-1 py-1 text-center text-sm">{{ shot.TargetShotZAP }}</td>
                    <td *ngIf="!isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm">{{ isDecimalPrimaryDisplay ? getShotDecimalValue(shot) : formatShotValue(getShotDecimalValue(shot)) }}</td>
                    <td *ngIf="showDecimalValues && !isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm">{{ getShotDecimalValue(shot) }}</td>
                    <td *ngIf="isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm">{{ formatShotValue(getShotDecimalValue(shot)) }}</td>
                    <td *ngIf="isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm">{{ getShotTeilerValue(shot) }}</td>
                    <td class="border border-gray-300 px-1 py-1 text-center text-sm">{{ shot.inner_center === 'D' ? 'Da' : 'Ne' }}</td>
                  </tr>
                </ng-container>
                <tr>
                  <td class="border border-gray-300 px-1 py-1 text-center text-sm"><strong>Skupaj</strong></td>
                  <td *ngIf="!isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm"><strong>{{ isDecimalPrimaryDisplay ? getSeriesDecimalValue(targetData[0], ['S10', 'S20', 'S30', 'S40', 'S50', 'S60'][idx], idx) : getSeriesWholeValue(targetData[0], ['S10', 'S20', 'S30', 'S40', 'S50', 'S60'][idx], idx) }}</strong></td>
                  <td *ngIf="showDecimalValues && !isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm">
                    <strong>{{ getSeriesDecimalValue(targetData[0], ['S10', 'S20', 'S30', 'S40', 'S50', 'S60'][idx], idx) }}</strong>
                  </td>
                  <td *ngIf="isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm">
                    <strong>{{ getSeriesWholeValue(targetData[0], ['S10', 'S20', 'S30', 'S40', 'S50', 'S60'][idx], idx) }}</strong>
                  </td>
                  <td *ngIf="isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm"><strong>{{ getSeriesTeilerTotal(idx) }}</strong></td>
                  <td class="border border-gray-300 px-1 py-1 text-center text-sm">{{ getSeriesInnerCenters(idx) }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </div>
      </div>
    </div>
  </div> 


  <div *ngIf="isSeriesView" class="target-series-view">
    <div class="target-series-grid">
      <ng-container *ngFor="let target of targetData">
            <ng-container *ngFor="let series of getValidSeries(target); let i = index">
                <div class="target-series-card">
                  <div class="target-series-heading">
                    <strong>{{ getSeriesLabel(series) }}</strong>
                    <span *ngIf="isTeilerDisplay">Decimalno: {{ getSeriesDecimalValue(target, series, i) }} | Teiler: {{ getSeriesTeilerTotal(i) }}</span>
                    <span *ngIf="!isTeilerDisplay">Skupaj: {{ isDecimalPrimaryDisplay ? getSeriesDecimalValue(target, series, i) : getSeriesWholeValue(target, series, i) }}<ng-container *ngIf="showDecimalValues"> / {{ isDecimalPrimaryDisplay ? getSeriesWholeValue(target, series, i) : getSeriesDecimalValue(target, series, i) }}</ng-container></span>
                  </div>
                  <canvas #targetCanvas [id]="'canvas-' + target.targetID + '-' + series" width="500" height="500" class="target-series-canvas"></canvas>
                  <div class="target-shot-table-wrap">
                    <table class="target-shot-table">
                      <thead>
                        <tr>
                          <th class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">Strel</th>
                          <th *ngIf="!isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">{{ isDecimalPrimaryDisplay ? 'Decimalno' : 'vrednost' }}</th>
                          <th *ngIf="showDecimalValues && !isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">decimalna vrednost</th>
                          <th *ngIf="isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">Celi</th>
                          <th *ngIf="isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">Teiler</th>
                          <th class="border border-gray-300 px-1 py-1 text-center text-sm bg-gray-100 font-semibold">Notranji center</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let shot of getSeriesShots(i)">
                          <tr (click)="selectShot(getShotIndex(shot))" [class.selected-shot-row]="selectedShotIndex === getShotIndex(shot)" class="cursor-pointer hover:bg-yellow-50">
                            <td class="border border-gray-300 px-1 py-1 text-center text-sm">{{ shot.TargetShotZAP }}</td>
                            <td *ngIf="!isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm">{{ isDecimalPrimaryDisplay ? getShotDecimalValue(shot) : formatShotValue(getShotDecimalValue(shot)) }}</td>
                            <td *ngIf="showDecimalValues && !isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm">{{ getShotDecimalValue(shot) }}</td>
                            <td *ngIf="isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm">{{ formatShotValue(getShotDecimalValue(shot)) }}</td>
                            <td *ngIf="isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm">{{ getShotTeilerValue(shot) }}</td>
                            <td class="border border-gray-300 px-1 py-1 text-center text-sm">{{ shot.inner_center === 'D' ? 'Da' : 'Ne' }}</td>
                          </tr>
                        </ng-container>
                        <tr>
                          <td class="border border-gray-300 px-1 py-1 text-center text-sm"><strong>Skupaj</strong></td>
                          <td *ngIf="!isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm"><strong>{{ isDecimalPrimaryDisplay ? getSeriesDecimalValue(target, series, i) : getSeriesWholeValue(target, series, i) }}</strong></td>
                          <td *ngIf="showDecimalValues && !isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm"><strong>{{ getSeriesDecimalValue(target, series, i) }}</strong></td>
                          <td *ngIf="isDecimalPrimaryDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm"><strong>{{ getSeriesWholeValue(target, series, i) }}</strong></td>
                          <td *ngIf="isTeilerDisplay" class="border border-gray-300 px-1 py-1 text-center text-sm"><strong>{{ getSeriesTeilerTotal(i) }}</strong></td>
                          <td class="border border-gray-300 px-1 py-1 text-center text-sm">{{ getSeriesInnerCenters(i) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            </ng-container>
      </ng-container>
    </div>
  </div>
</div>
</main>